/**
 * 课程类型，支持key和value的相互映射，后续都从此枚举对象中获取课程类型
 */
export const ENU_COURSE_TYPE = {
  1: 'article', // 图文课程
  2: 'video', // 视频课程
  3: 'series', // 系列课程
  4: 'offline', // 线下课程
  5: 'live', // 直播课程
  6: 'certify',
  7: 'training',

  ARTICLE: 1, // 图文课程
  VIDEO: 2, // 视频课程
  SERIES: 3, // 系列课程
  OFFLINE: 4, // 线下课程
  LIVE: 5, // 直播课程
  CERTIFY: 6, // 认证课
  TRAINING: 7, // 训练营
};

export const ENU_COURSE_CHAPTER_TYPE = {
  100: 'practiceTask', // 实践任务
  ...ENU_COURSE_TYPE,
  PRACTICE_TASK: 100, // 实践任务
};

export const ENU_COURSE_TYPE_NAME = {
  1: '图文',
  2: '视频',
  3: '系列',
  4: '线下',
  5: '直播',
  6: '综合',
  7: '训练营',
};

export const CHAPTER_TYPE_NAME = {
  ...ENU_COURSE_TYPE_NAME,
  100: '实践',
};

export const filterCourseTypes = [
  {
    text: '图文课程',
    key: 'article',
    value: 1,
  },
  {
    text: '视频课程',
    key: 'video',
    value: 2,
  },
  {
    text: '系列课程',
    key: 'series',
    value: 3,
  },
  {
    text: '线下课程',
    key: 'offline',
    value: 4,
  },
  {
    text: '直播课程',
    key: 'live',
    value: 5,
  },
  {
    text: '综合课程',
    key: 'certify',
    value: 6,
  },
  {
    text: '训练营',
    key: 'training',
    value: 7,
  },
];

export const FILTER_CHAPTER_TYPES = [
  ...filterCourseTypes,
  {
    text: '实践任务',
    key: 'practiceTask',
    value: 100,
  },
];

// 课程的学习模式
export const COURSE_STUDY_MODE = {
  DEFAULT_MODE: 0, // 默认的学习模式，兼容老的数据
  FEEL_MODE: 1, // 自由学习模式
  DATE_MODE: 2, // 时间解锁模式
};

export const ENU_COURSE_TYPE_KEY = {
  1: 'article', // 图文课程
  2: 'video', // 视频课程
  3: 'series', // 系列课程
  4: 'offline', // 线下课程
  5: 'live', // 直播课程
  6: 'certify',
  7: 'training',
};

// 课程的学习模式
export const ENU_COURSE_STUDY_MODE = {
  DEFAULT_MODE: 0, // 默认的学习模式，兼容老的数据
  FEEL_MODE: 1, // 自由学习模式
  DATE_MODE: 2, // 时间解锁模式
};

// 考试类型
export const ENU_EXAM_TYPE = {
  NO_EXAM: 0,
  INNER_EXAM: 1,
  OUTER_EXAM: 2,
};

// 考试状态
export const ENU_EXAM_STATUS = {
  START: 0,
  FINISHED: 1,
  NOT_START: 2,
};

// 实践任务的类型
export const PRACTICE_TASK_TYPE = [
  {
    label: '文本',
    value: 1,
    key: 'content',
  },
  {
    label: '图片',
    value: 2,
    key: 'pictureLinks',
  },
  {
    label: '文件',
    value: 3,
    key: 'fileLinks',
  },
];

// 实践任务完成状态

export const PRACTICE_TASK_RET_STATUS = [
  {
    label: '待完成',
    value: 0,
    en: 'INIT',
  },
  {
    label: '待审核',
    value: 1,
    en: 'PADDING',
  },
  {
    label: '已通过',
    value: 6,
    en: 'APPROVE',
  },
  {
    label: '已驳回',
    value: 7,
    en: 'REJECT',
  },
];

export const PRACTICE_TASK_RET_MAP = PRACTICE_TASK_RET_STATUS.reduce((last, now) => {
  const { en, value } = now;
  last[en] = value;
  last[value] = en;
  return last;
}, {});

/**
 * 直播频道状态
 */
export const ENU_LIVE_STATUS = {
  NOT_BEGIN: 'NOT_BEGIN',
  LIVE: 'LIVE',
  PLAYBACK: 'PLAYBACK',
  FINISHED: 'FINISHED',
};

export const ENU_COURSE_AD_SWITCH = {
  NONE: 0,
  WHITE_LIST: 1,
  BLANK_LIST: 2,
};

export const SIGNIN_STATUS = {
  hadSigned: 1,
  manualHadSignout: 2,
  autoHadSignout: 4,
};

export const ENU_COURSE_RESOURCE_TYPE = {
  FILE: 1, // 文件类型
  URL: 2, //  配置连接
};

export const ENU_COURSE_PHOTO_AUDIT_STATUS = {
  NOT_SUBMIT: 0, // 待提交
  PENDING: 1, // 审核中
  PASSED: 6, // 已通过
  NOT_PASSED: 7, // 未通过
};

export const ENU_COURSE_PHOTO_AUDIT_STATUS_LABEL = {
  0: 'NOT_SUBMIT',
  1: 'PENDING',
  6: 'PASSED',
  7: 'NOT_PASSED',
};

export const ENU_COURSE_PHOTO_AUDIT_STATUS_TEXT = {
  0: '未上传',
  1: '待审核',
  6: '审核已通过',
  7: '审核未通过',
};

export const ENU_COURSE_PHOTO_AUDIT_STATUS_TEXT_NEW = {
  0: '需上传个人照片用于证书发放',
  1: '审核中...',
  6: '', // 这里的空字符串可以根据需要填充
  7: '审核失败，请重新上传',
};

export const ENU_COURSE_COMMENT = {
  CLOSE: 0,
  OPEN: 1,
};

export const ENU_COURSE_COMMENT_REMIND = {
  CLOSE: 0,
  OPEN: 1,
};

export const ENU_COURSE_HIDE_COMMENT = {
  SHOW: 0,
  HIDE: 1,
};

export const ENU_COMPONENT_TYPE = {
  EXAM: 'exam',
  CERTIFICATE: 'certificate',
  SIGN: 'sign',
  STUDY_REPORT: 'studyReport',
  SURVEY: 'survey',
  DAKA: 'daka',
  MATERIAL: 'material',
};

/**
 * 课程详情类型
 */
export const ENU_COURSE_CONTENT_TYPE = {
  /**
   * 富文本类型
   */
  HTML: 0,
  /**
   * 文件类型，目前只支持PDF
   */
  FILE: 1,
};
